import { listHistory, type SessionSummary } from '@gymtv/data';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { fmtDate, fmtDuration, fmtVolume } from '../lib/format';
import { supabase } from '../lib/supabase';

const PAGE = 25;

export function History() {
  const nav = useNavigate();
  const { units } = useAuth();
  const [rows, setRows] = useState<SessionSummary[] | null>(null);
  const [more, setMore] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listHistory(supabase, undefined, PAGE).then((r) => {
      setRows(r);
      setMore(r.length === PAGE);
    }, (e) => setError(e.message));
  }, []);

  return (
    <>
      <div className="page-head">
        <h1>History</h1>
      </div>
      {error && <p className="error">{error}</p>}
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Date</th>
              <th>Workout</th>
              <th>Sets</th>
              <th>Volume</th>
              <th>Time</th>
              <th>PBs</th>
            </tr>
          </thead>
          <tbody>
            {rows?.length === 0 && (
              <tr>
                <td colSpan={6} className="muted">Finished workouts appear here.</td>
              </tr>
            )}
            {rows?.map((s) => (
              <tr key={s.id} className="link" onClick={() => nav(`/history/${s.id}`)}>
                <td className="num">{fmtDate(s.started_at)}</td>
                <td><b>{s.title}</b></td>
                <td className="num">{s.sets_done}</td>
                <td className="num">{fmtVolume(s.volume, units)}</td>
                <td className="num">{fmtDuration(s.duration_s)}</td>
                <td>{s.pb_count > 0 ? <span className="pill warn">{s.pb_count} PB{s.pb_count > 1 ? 's' : ''}</span> : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows && more && (
        <button
          onClick={() =>
            listHistory(supabase, rows[rows.length - 1]!.started_at, PAGE).then((r) => {
              setRows([...rows, ...r]);
              setMore(r.length === PAGE);
            })
          }
        >
          Load older
        </button>
      )}
    </>
  );
}
